<template>
  <div class="row justify-content-center position-relative row-cols-1 row-cols-md-2 row-cols-xl-4">
    <span
      v-for="i in 4"
      :key="i"
      class="pills-image"
      :class="[`pill-card-1-${i}`]"
    />
    <div
      v-if="contract.productId === 16"
      class="col mb-2"
    >
      <v-local
        :local="contract.risk.local"
        :is-editable="isAmendmentEditableSubscription"
        class="h-100"
        @edit="openModal"
      />
    </div>
    <div
      v-if="[1, 2].includes(contract.productId)"
      class="col mb-2"
    >
      <v-activities
        class="h-100"
        :is-editable="isAmendmentEditableSubscription && contract.insurerId !== 28"
        @edit="openModal"
      />
    </div>
    <div
      v-for="card in filterCardByProductId"
      :key="`small-${card.label}`"
      class="col mb-2"
    >
      <v-card-small
        :modal-component="card.type"
        :is-editable="card.editable"
        color="blue-300"
        class="h-100 text-center"
        @edit="openModal"
      >
        <template #icon>
          <v-icon
            v-if="card.icon"
            :icon="card.icon"
            width="24"
            height="24"
            folder="common/svg"
          />
        </template>
        <template #title>
          {{ card.label }}
        </template>
        <template #content>
          {{ card.getter() }}
        </template>
      </v-card-small>
    </div>
    <div
      v-if="contract.productId === 16"
      class="col mb-2"
    >
      <v-deductible-premium
        :deductible="contract.deductible"
        :annual-premium="contract.annualPremium"
        :is-editable="getDeductibleEditability"
        class="h-100"
        @edit="openModal"
      />
    </div>
  </div>
</template>
<script>
import { get } from 'lodash-es';
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';

import formatter from '@/utils/_Strings';

import {
  ContractSmallCard,
  ContractSmallCardLocal,
  ContractSmallCardActivities,
  ContractSmallCardDeductibleAndPremium,
} from '@/components/contracts/cards';

const [RCP, RDD, CYBER, MRP, TELEWORK, TRI, MISSION] = [1, 2, 5, 16, 42, 23, 13];
const [MUTUELLE] = [18];

export default {
  components: {
    'v-local': ContractSmallCardLocal,
    'v-card-small': ContractSmallCard,
    'v-activities': ContractSmallCardActivities,
    'v-deductible-premium': ContractSmallCardDeductibleAndPremium,
  },
  mixins: [ui],
  // eslint-disable-next-line max-lines-per-function
  data() {
    return {
      cards: [
        {
          label: 'Fumeur',
          products: [9],
          getter: this.getSmokerStatus,
          icon: 'cloud',
        },
        {
          label: 'Date d\'anniversaire',
          products: [9],
          getter: this.getBirthDate,
          icon: 'balloon',
        },
        {
          label: 'Capital',
          products: [9],
          getter: this.getBirthDate,
          icon: 'money',
        },

        {
          label: 'Adresse',
          products: [4],
          getter: this.getAddress,
          icon: 'pin',
        },
        {
          label: 'Statut',
          products: [4],
          getter: this.getBeneficiaryStatus,
          icon: 'tie',
        },
        {
          label: 'Revenu annuel net',
          products: [4],
          getter: this.getAnnualIncome,
          icon: 'money',
        },
        {
          label: 'Dividende',
          products: [4],
          getter: this.getDividend,
          icon: 'percentage',
        },

        { label: 'Montant de garantie', products: [9], getter: this.getBeneficiaryLiability },
        {
          label: 'Nombre de salariés cadres',
          products: [MUTUELLE],
          getter: this.getExecutivesNumber,
          icon: 'users',
        },
        {
          label: 'Nombre de salariés non-cadres',
          products: [MUTUELLE],
          getter: this.getNonExecutivesNumber,
          icon: 'users',
        },
        {
          label: 'Valeur du contenu',
          type: 'local-content',
          products: [MRP],
          getter: this.getLocalContent,
          editable: true,
          icon: 'diamond',
        },
        {
          label: 'Valeur du matériel fixe',
          type: 'equipment-fixe-content',
          products: [TRI],
          getter: this.getFixeContent,
          editable: true,
          icon: 'diamond',
        },
        {
          label: 'Valeur du matériel mobile',
          type: 'equipment-mobil-content',
          products: [TRI],
          getter: this.getMobilContent,
          editable: true,
          icon: 'diamond',
        },
        {
          label: 'Franchise',
          type: 'deductible',
          products: [RCP, RDD, CYBER, TELEWORK, MISSION],
          getter: this.getDeductibleName,
          icon: 'umbrella',
        },
        {
          label: 'Prime annuelle TTC',
          products: [RCP, RDD, CYBER, TELEWORK, TRI, MISSION],
          getter: this.getAnnualPremium,
          icon: 'piggy-bank',
        },
        {
          label: 'Chiffre d\'affaires',
          type: 'revenue',
          products: [RCP, RDD, CYBER, MRP, TELEWORK, TRI, MISSION],
          getter: this.getReportedRevenue,
          editable: true,
          icon: 'money-bag',
        },
        {
          label: 'Numéro ORIAS',
          type: 'orias-number',
          products: [RCP, RDD, CYBER, MRP, TELEWORK, TRI, MISSION, MUTUELLE],
          getter: this.getOriasNumber,
          editable: false,
          icon: 'puzzle',
        },
        {
          label: 'N° d\'enregistrement au registre des Experts Comptables',
          type: 'accountant-number',
          products: [RCP],
          getter: this.getAccountantNumber,
          editable: false,
          icon: 'puzzle',
        },
        {
          label: 'Date d\'enregistrement',
          type: 'accountant-registration-date',
          products:  [RCP],
          getter: this.getAccountantRegistrationDate,
          editable: false,
          icon: 'calendar',
        },
        {
          label: 'Numéro de commissaire aux comptes',
          type: 'auditor-number',
          products:  [RCP, MRP],
          getter: this.getAuditorNumber,
          editable: false,
          icon: 'puzzle',
        },
        {
          label: 'Numéro de géomètre',
          type: 'surveyor-number',
          products:  [RCP, MRP],
          getter: this.getSurveyorNumber,
          editable: false,
          icon: 'puzzle',
        },
        {
          label: 'Numéro de carte professionnelle',
          type: 'professional-card-number',
          products:  [RCP, MRP],
          getter: this.getProfessionalCardNumber,
          editable: false,
          icon: 'puzzle',
        }

      ],
    };
  },
  computed: {
    ...mapGetters({
      contract: 'contract/get',
    }),
    filterCardByProductId() {
      // TODO : enlever la franchise pour la PR
      // TODO : ajouter une condition pour filtrer les cartes si profession règlementée
      return this.cards
        .filter(({ products }) => products.includes(this.contract.productId))
        .map((card) => Object.assign({}, card, {
          editable: this.isAmendmentEditableSubscription && Boolean(card.editable),
        }))
        .filter((card) => card.getter() !== 'N/A');
    },
    isAmendmentEditableSubscription() {
      return this.contract.status === 'AMENDMENT'
        && this.contract.leadStatus !== 'AMENDMENT_VALIDATED'
        && Boolean(this.contract.policyId)
        && !this.contract.activeVersionId
        && this.contract.delegation
        && !this.contract.derogation;
    },
    getDeductibleEditability() {
      const MADP = 28;
      const { deductibles } = this.contract;
      const canBeEdited = this.isAmendmentEditableSubscription
        && (deductibles && deductibles.length > 0)
        && this.contract.delegation
        && !this.contract.derogation;
      if (this.contract.insurerId === MADP) {
        return false;
      }
      return canBeEdited;
    },
  },
  methods: {
    openModal(type) {
      this.ui_showModalAmendment(type, true);
    },
    formatPrice(price) {
      const formattedPrice = parseFloat(price || 0)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        .replace('.', ',');
      return `${formattedPrice} €`;
    },

    // getters for display contract
    getBirthDate() {
      const birthdate = get(this.contract, 'risk.beneficiary.birthDate');
      if (birthdate) {
        return birthdate.split('-').reverse().join('/');
      }
      return 'N/A';
    },
    getDeductibleName() {
      const { deductibles } = this.contract;
      if (deductibles && deductibles.length > 0) {
        const deductible = deductibles.find(({ enabled }) => enabled);
        if (deductible === 0) {
          return 'Aucune franchise';
        }
        if (deductible) {
          return deductible.name;
        }
      // eslint-disable-next-line max-lines
      }

      return 'N/A';
    },
    getAnnualPremium() {
      const annualPremium = get(this.contract, 'annualPremium');
      if (annualPremium) {
        return this.formatPrice(annualPremium);
      }
      // eslint-disable-next-line max-lines
      return 'N/A';
    },
    getReportedRevenue() {
      const revenue = get(this.contract, 'risk.reportedRevenue');
      if (revenue) {
        return this.formatPrice(revenue);
      }
      return 'N/A';
    },
    getExecutivesNumber() {
      return get(this.contract, 'risk.executivesAverageAge', 'N/A');
    },
    getNonExecutivesNumber() {
      return get(this.contract, 'risk.nonExecutivesAverageAge', 'N/A');
    },
    getSmokerStatus() {
      const isSmoker = get(this.contract, 'risk.surveys[0]', null);
      if (isSmoker === null) {
        return 'N/A';
      }
      return isSmoker.answer ? 'Oui' : 'Non';
    },
    getAddress() {
      const beneficiary = get(this.contract, 'risk.beneficiary');
      if (beneficiary) {
        return formatter.addressFormatter(beneficiary);
      }
      return 'N/A';
    },
    getLocalContent() {
      const content = get(this.contract, 'risk.local.content');
      if (content) {
        // eslint-disable-next-line max-lines
        return this.formatPrice(content);
      }
      return 'N/A';
    },
    getFixeContent() {
      const fixeContent = get(this.contract, 'risk.equipment.fixContent');
      if (fixeContent) {
        return this.formatPrice(fixeContent);
      }
      return 'N/A';
    },
    getMobilContent() {
      const mobileContent = get(this.contract, 'risk.equipment.mobileContent');
      if (mobileContent) {
        return this.formatPrice(mobileContent);
      }
      return 'N/A';
    },
    getDividend() {
      const dividend = get(this.contract, 'risk.beneficiary.dividend');
      if (dividend === 0) {
        return this.formatPrice(dividend);
      }
      if (dividend) {
        return this.formatPrice(dividend);
      }
      return 'N/A';
    },
    getBeneficiaryLiability() {
      const liability = get(this.contract, 'risk.beneficiary.liability');
      if (liability) {
        return this.formatPrice(liability);
      }
      return 'N/A';
    },
    getBeneficiaryStatus() {
      return get(this.contract, 'risk.beneficiary.position.label', 'N/A');
    },
    getAnnualIncome() {
      const annualIncome = get(this.contract, 'risk.beneficiary.annualIncome');
      if (annualIncome) {
        return this.formatPrice(annualIncome);
      }
      return 'N/A';
    },
    /// added the orias number getter
    getOriasNumber() {
      const oriasNumber = get(this.contract, 'risk.oriasNumber');
      return oriasNumber || 'N/A';
    },
    getAccountantNumber() {
      const accountantNumber = get(this.contract, 'risk.accountantNumber');
      return accountantNumber || 'N/A';
    },
    getAccountantRegistrationDate() {
      const registrationDate = get(this.contract, 'risk.accountantRegistrationDate');
      if (registrationDate) {
        return registrationDate.split('-').reverse().join('/');
      }
      return 'N/A';
    },
    getAuditorNumber() {
      const auditorNumber = get(this.contract, 'risk.auditorNumber');
      return auditorNumber || 'N/A';
    },
    getSurveyorNumber() {
      const surveyorNumber = get(this.contract, 'risk.surveyorNumber');
      return surveyorNumber || 'N/A';
    },
    getProfessionalCardNumber() {
      const professionalCardNumber = get(this.contract, 'risk.professionalCard.cardNumber');
      return professionalCardNumber || 'N/A';
    },
  },
};
</script>
<style scoped>
.pills-image {
  height: 12px;
  border-radius: 60px;
  position: absolute;
  z-index: 0;
}

.pill-card-1-1 {
  left: 10%;
  width: 64px;
  top: -15%;
  background-color: var(--bs-blue-500);
}

.pill-card-1-2 {
  left: 16px;
  width: 64px;
  bottom: 30%;
  background-color: var(--bs-green-500);
}

.pill-card-1-3 {
  left: 40%;
  width: 64px;
  bottom: 6%;
  background-color: var(--bs-yellow-500);
}

.pill-card-1-4 {
  right: 16px;
  width: 64px;
  bottom: 30%;
  background-color: var(--bs-pink-500);
}
</style>
